import React from 'react';

const FileModal = ({ showModal, handleClose, Files, mode, handleRemoveImage, setSelectedFiles }) => {

  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedFiles((prev) => [...prev, e.target?.result]);
      };
      reader.readAsDataURL(file);
    }
  }

  return (
    <>
      <div className={`modal ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">ไฟล์</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span>&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <div style={{ width: "50%", marginTop: "30px", position: "relative", justifySelf: "center", display: "flex" }}>
                  <table id="basic-datatables" className="table table-striped table-hover">
                    <thead className="thead-dark">
                      <tr>
                        <th className="text-center" style={{ width: "2%" }}>
                          #
                        </th>
                        <th
                          className="text-center" style={{ width: "8%" }}>
                          ชื่อ
                        </th>
                        <th className="text-center" style={{ width: "1%" }}>
                          ดู
                        </th>
                        {mode === "U" && (
                          <th className="text-center" style={{ width: "1%" }}>
                            ลบ
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {Files.length > 0 ? (
                        Files.map((data, index) => {

                          return (
                            <tr
                              key={index}
                              style={{
                                cursor: "pointer",
                                backgroundColor: "transparent",
                                transition: "background-color 0.3s ease",
                              }}
                            >
                              <td className="text-center">
                                {index + 1}
                              </td>
                              <td
                                className="text-center">
                                {data.slice(-20)}
                              </td>
                              <td className="text-center">
                                <button
                                  className="btn btn-link btn-sm px-3"
                                  onClick={() => window.open(`${data}`, "_blank")}
                                >
                                  <i
                                    className="fa fa-eye"
                                    style={{
                                      color: "rgb(239, 108, 0)",
                                      fontSize: "16px",
                                    }}
                                  />
                                </button>
                              </td>
                              {mode === "U" && (
                                <td className="text-center">
                                  <button
                                    className="btn btn-link btn-sm px-3"
                                    onClick={() => handleRemoveImage(index)}
                                  >
                                    <i className="fa fa-trash-alt"
                                      style={{
                                        color: "rgb(239, 108, 0)",
                                        fontSize: "16px",
                                      }}
                                    />
                                  </button>
                                </td>
                              )}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14}>
                            <center>
                              <h5>ไม่พบข้อมูล</h5>
                            </center>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleClose}>ปิด</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FileModal;